module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAYCAMAAAD08pwfAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAQlBMVEUAAACvr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr6+vr69BWXQrAAAAFXRSTlMAa0T8JvAS2wa9lmxFJxOXmBQoRm2gm+ObAAAAAWJLR0QAiAUdSAAAAAlwSFlzAAALEgAACxIB0t1+/AAAAFZJREFUGNNNz0kCgCAMA8AgIqDinv9/1Qsp7WkOXVJAFUxTlObEriWzs1SKK8WN4h7Flth5ZHaWSvGk8Rp0DbhtDHhsGfDaCeAbdHF8SBcdaPaQfxMIP9PkCYdEbs1xAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ../server/public/static/images/global/type-arrows/left-grey5@2x.png
// module id = 785
// module chunks = 0 1 2 3 4